import React, { useEffect, useCallback } from 'react';
import styled from 'styled-components';
import Modal from 'gatsby-theme-core/src/components/modal';
import Form from './form';
import VehicleForm from './vehicle-form';
import { useModals } from '../../../context/modals';

const PagebuilderModal = ({
  id,
  identifier,
  title,
  strapiForm,
  vehicleForForm,
  childStrapiPagebuilderPagebuilderInteractionsModalContent,
  autoOpen,
  openAfterSeconds,
}) => {
  const {
    addModal,
    setModalOpen,
    isModalOpen,
  } = useModals();

  useEffect(() => {
    addModal(identifier || id);
  }, [
    addModal,
    identifier,
    id,
  ]);

  const isOpen = isModalOpen(identifier || id);
  const seconds = parseFloat((openAfterSeconds || 0) * 1000);

  useEffect(() => {
    // set true when autoOpen returns null from graphQL
    if (!(autoOpen ?? true)) {
      return undefined;
    }
    if (Number.isNaN(seconds)) {
      return undefined;
    }
    const timer = setTimeout(() => {
      setModalOpen(identifier || id, true);
    }, seconds);
    return () => clearTimeout(timer);
  }, [
    autoOpen,
    setModalOpen,
    identifier,
    id,
    seconds,
  ]);

  const onCloseModal = useCallback(
    () => setModalOpen(identifier || id, false),
    [identifier, id, setModalOpen],
  );

  return (
    <Modal
      content={childStrapiPagebuilderPagebuilderInteractionsModalContent}
      open={isOpen}
      onCloseModal={onCloseModal}
      title={title}
    >
      {vehicleForForm && (
        <VehicleForm vehicle={vehicleForForm} />
      )}
      {!vehicleForForm && strapiForm && (
        <Form strapiForm={strapiForm} />
      )}
    </Modal>
  );
};

export default styled(PagebuilderModal)``;
